import _round from 'lodash/round';

export const getTargetApplicants = (
  budget?: number | null,
  cpa?: number | null,
) => {
  return budget && cpa ? Math.round(budget / cpa) : null;
};

export const getTargetHires = (
  budget?: number | null,
  conversion?: number | null,
  cpa?: number | null,
) => {
  return budget && conversion && cpa
    ? Math.round(((budget / cpa) * conversion) / 100)
    : null;
};

export const getTargetConversion = (
  budget?: number | null,
  hires?: number | null,
  cpa?: number | null,
) => {
  return budget && hires && cpa
    ? Math.min(_round((100 * hires * cpa) / budget, 2), 100)
    : null;
};

export const getTargetCpa = (
  budget?: number | null,
  applicants?: number | null,
) => {
  return budget && applicants ? _round(budget / applicants, 2) : null;
};
